import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Edit: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3266 2.32691C12.6195 2.03402 13.0944 2.03402 13.3873 2.32691L16.2444 5.18405C16.3851 5.3247 16.4641 5.51547 16.4641 5.71438C16.4641 5.91329 16.3851 6.10406 16.2444 6.24471L8.38728 14.1019C8.24663 14.2425 8.05586 14.3215 7.85695 14.3215H4.99981C4.58559 14.3215 4.24981 13.9857 4.24981 13.5715V10.7144C4.24981 10.5155 4.32883 10.3247 4.46948 10.1841L12.3266 2.32691ZM5.74981 11.025V12.8215H7.54629L14.6534 5.71438L12.857 3.9179L5.74981 11.025ZM3.53552 17.143C3.53552 16.7287 3.87131 16.393 4.28552 16.393H16.4284C16.8426 16.393 17.1784 16.7287 17.1784 17.143C17.1784 17.5572 16.8426 17.893 16.4284 17.893H4.28552C3.87131 17.893 3.53552 17.5572 3.53552 17.143Z"
      />
    </svg>
  )
}

Edit.displayName = 'Edit'

export default withIcon(Edit)
